import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CryptoInterface } from '../../../interfaces/crypto.interface'
import { CryptoService } from 'dmmp-services'
import * as moment_ from 'moment'

@Component({
  selector: 'dmmp-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent implements OnInit {
  @Input() data
  @Input() identifier: string
  @Input() urlPayment: string
  @Input() privateKey: string
  @Input() programId: string
  @Input() programPrice: string
  @Input() programExpiration: string
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() close = new EventEmitter()
  medias = [{ style: 'large', media: '(min-width:421px)' }]
  cryptoJson: CryptoInterface
  moment = moment_
  idCryptoElement = 'buy'

  constructor(private cryptoService: CryptoService) {
  }

  ngOnInit(): void {
    this.cryptoJson = {
      id_course: this.programId,
      price: this.programPrice,
      date_purchase: '',
      expiration_days: this.programExpiration,
    }
    this.cryptoPayment()
  }

  anchor(event, data) {
    if (data.indexOf('#') === 0 && data.length > 1) {
      this.anchorCustom.emit({ event: event, id: data })
    }
  }

  cryptoPayment() {
    if (
      this.data.id_element === this.idCryptoElement &&
      this.data.link &&
      this.data.link.length > 0
    ) {
      this.cryptoJson.date_purchase = this.moment().format('X')
      const code = this.cryptoService.cryptoCode(this.cryptoJson, this.privateKey)
      this.data.link[0].link = `${this.urlPayment}/${this.programId}?token=${code}`
    }
  }
}
